import ScrollTransition from './scroll-transition'

class Animator {
	constructor() {
		let transitions = [
			new ScrollTransition()
		]
		
		transitions.forEach((transition) => {
			transition.animateIn()
		})
	}
}

export default Animator
